import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getMessaging } from 'firebase/messaging';

// This file handles the Firebase initialization.
// It's imported once at the start of the app, ensuring Firebase doesn't get initialized multiple times.

// --- Firebase Configuration ---
// This configuration object is used to connect to your Firebase project.
export const firebaseConfig = {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    };

// --- Initialize Firebase and Export Services ---
// Initialize the Firebase app with the configuration.
const app = initializeApp(firebaseConfig);

export const appId = "whispers-of-harmony"; // Replace with your actual Firebase App ID
export const initialAuthToken = null; // Or a custom auth token if applicable
// Initialize and export the specific Firebase services you need.
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const rtdb = getDatabase(app); // Realtime Database for presence
export const messaging = getMessaging(app);

// --- Connect to Emulators for Local Development ---
// This block checks if the app is running on localhost.
// If it is, it connects the Firebase services to the local emulators.
// This allows you to test your backend functions (like the AI feature) locally.
/*if (window.location.hostname === "localhost") {
  console.log("Development environment detected. Connecting to Firebase Emulators.");
  // Point the SDKs to the emulators
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectStorageEmulator(storage, "localhost", 9199);
}*/


// Export the app instance itself if needed elsewhere.
export default app;